  <div [formGroup]="group">
    <!-- [formControlName]="field.name" -->
    <div class="file-label">{{field.label}}</div>
    <kendo-fileselect
        [accept]="field.additionalOptions?.accept"
        [multiple]="field.additionalOptions?.multiple"
        [showFileList]="field.additionalOptions?.showFileList"
        [restrictions]="field.additionalOptions?.restrictions"
        (select)="filesSelected($event)"
        (remove)="fileRemoved($event)"
        >
    </kendo-fileselect>
    <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
      <mat-error class="file-error" *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
    </ng-container>
  </div>

